const useRegisterForNotifications = (): (() => void) => {
    return () => {};
};

export default useRegisterForNotifications;
